import React from 'react';
import { css, ThemeProvider, Global } from '@emotion/react';
import _styled from '@emotion/styled/base';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { position, layout, space, color, background, border, flexbox, flex, shadow, typography, grid, get } from 'styled-system';
var hideFocusRingsDataAttribute = 'data-hidefocusrings';

var FocusVisible = function FocusVisible(_ref) {
  var _ref2;

  var children = _ref.children;

  var _React$useState = React.useState(false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  React.useEffect(function () {
    var eventName = focusVisible ? 'keydown' : 'mousemove';

    var toggleFocusRings = function toggleFocusRings() {
      setFocusVisible(function (f) {
        return !f;
      });
    };

    window.addEventListener(eventName, toggleFocusRings);
    return function () {
      window.removeEventListener(eventName, toggleFocusRings);
    };
  }, [focusVisible]);
  return /*#__PURE__*/React.createElement("div", focusVisible ? (_ref2 = {}, _ref2[hideFocusRingsDataAttribute] = true, _ref2) : {}, children);
};

var FocusVisibleProvider = function FocusVisibleProvider(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(FocusVisible, null, children);
};

var defaultTheme = {
  breakpoints: ['576px', '768px', '1280px'],
  space: {
    px: '1px',
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    12: '3rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    32: '8rem',
    40: '10rem',
    48: '12rem',
    56: '14rem',
    64: '16rem'
  }
};
var ThemeContext = /*#__PURE__*/React.createContext(defaultTheme);

var useTheme = function useTheme() {
  var theme = React.useContext(ThemeContext);

  if (theme === null) {
    throw new Error('No theme available on context');
  }

  return theme;
};

var hideFocusRingsStyles = /*#__PURE__*/css("[", hideFocusRingsDataAttribute, "='true'] *{outline:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:hideFocusRingsStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var LayoutProvider = function LayoutProvider(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme,
      styles = _ref.styles,
      _ref$hideFocusRings = _ref.hideFocusRings,
      hideFocusRings = _ref$hideFocusRings === void 0 ? false : _ref$hideFocusRings,
      children = _ref.children;
  var t = Object.assign(defaultTheme, theme);
  var s = hideFocusRings ? [hideFocusRingsStyles, styles] : [styles];
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: t
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: t
  }, /*#__PURE__*/React.createElement(Global, {
    styles: s
  }), /*#__PURE__*/React.createElement(FocusVisibleProvider, null, children)));
};

LayoutProvider.displayName = 'LayoutProvider';

var Box = /*#__PURE__*/_styled('div', {
  shouldForwardProp: shouldForwardProp,
  target: "e19pbo6g0",
  label: "Box"
})(function () {
  return {
    minWidth: 0,
    margin: 0,
    padding: 0,
    boxSizing: 'border-box'
  };
}, position, layout, space, color, background, border, flexbox, flex, shadow, typography, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJveC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMEJZIiwiZmlsZSI6IkJveC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBBbGxIVE1MQXR0cmlidXRlcywgUmVhY3ROb2RlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHNob3VsZEZvcndhcmRQcm9wIGZyb20gJ0BzdHlsZWQtc3lzdGVtL3Nob3VsZC1mb3J3YXJkLXByb3AnO1xuaW1wb3J0IHtcbiAgcG9zaXRpb24sXG4gIGJvcmRlcixcbiAgc3BhY2UsXG4gIGxheW91dCxcbiAgY29sb3IsXG4gIGJhY2tncm91bmQsXG4gIGZsZXgsXG4gIGZsZXhib3gsXG4gIHNoYWRvdyxcbiAgdHlwb2dyYXBoeSxcbiAgUG9zaXRpb25Qcm9wcyxcbiAgTGF5b3V0UHJvcHMsXG4gIEZsZXhQcm9wcyxcbiAgU3BhY2VQcm9wcyxcbiAgQ29sb3JQcm9wcyxcbiAgQm9yZGVyUHJvcHMsXG4gIFNoYWRvd1Byb3BzLFxuICBCYWNrZ3JvdW5kUHJvcHMsXG4gIFR5cG9ncmFwaHlQcm9wcyxcbiAgRmxleGJveFByb3BzLFxufSBmcm9tICdzdHlsZWQtc3lzdGVtJztcblxuY29uc3QgQm94ID0gc3R5bGVkKCdkaXYnLCB7IHNob3VsZEZvcndhcmRQcm9wIH0pPEJveFByb3BzPihcbiAgKCkgPT4gKHtcbiAgICBtaW5XaWR0aDogMCxcbiAgICBtYXJnaW46IDAsXG4gICAgcGFkZGluZzogMCxcbiAgICBib3hTaXppbmc6ICdib3JkZXItYm94JyxcbiAgfSksXG4gIHBvc2l0aW9uLFxuICBsYXlvdXQsXG4gIHNwYWNlLFxuICBjb2xvcixcbiAgYmFja2dyb3VuZCxcbiAgYm9yZGVyLFxuICBmbGV4Ym94LFxuICBmbGV4LFxuICBzaGFkb3csXG4gIHR5cG9ncmFwaHlcbik7XG5cbmV4cG9ydCB0eXBlIEJveFByb3BzID0gUG9zaXRpb25Qcm9wcyAmXG4gIExheW91dFByb3BzICZcbiAgRmxleGJveFByb3BzICZcbiAgRmxleFByb3BzICZcbiAgU3BhY2VQcm9wcyAmXG4gIENvbG9yUHJvcHMgJlxuICBCb3JkZXJQcm9wcyAmXG4gIFNoYWRvd1Byb3BzICZcbiAgQmFja2dyb3VuZFByb3BzICZcbiAgVHlwb2dyYXBoeVByb3BzICZcbiAgQWxsSFRNTEF0dHJpYnV0ZXM8SFRNTEVsZW1lbnQ+ICYge1xuICAgIGFzPzogQXM7XG4gICAgY2hpbGRyZW4/OiBSZWFjdE5vZGU7XG4gIH07XG5cbnR5cGUgQXM8UCA9IGFueT4gPSBSZWFjdC5FbGVtZW50VHlwZTxQPjtcblxuQm94LmRpc3BsYXlOYW1lID0gJ0JveCc7XG5leHBvcnQgeyBCb3ggfTtcbiJdfQ== */");

Box.displayName = 'Box';

var Flex = /*#__PURE__*/_styled('div', {
  shouldForwardProp: shouldForwardProp,
  target: "eb91hxz0",
  label: "Flex"
})(function () {
  return {
    display: 'flex',
    minWidth: 0,
    margin: 0,
    padding: 0,
    boxSizing: 'border-box'
  };
}, position, layout, flex, flexbox, space, color, background, border, shadow, typography, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZsZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTBCYSIsImZpbGUiOiJGbGV4LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEFsbEhUTUxBdHRyaWJ1dGVzLCBSZWFjdE5vZGUgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgc2hvdWxkRm9yd2FyZFByb3AgZnJvbSAnQHN0eWxlZC1zeXN0ZW0vc2hvdWxkLWZvcndhcmQtcHJvcCc7XG5pbXBvcnQge1xuICBwb3NpdGlvbixcbiAgYm9yZGVyLFxuICBzcGFjZSxcbiAgbGF5b3V0LFxuICBjb2xvcixcbiAgYmFja2dyb3VuZCxcbiAgZmxleCxcbiAgZmxleGJveCxcbiAgc2hhZG93LFxuICB0eXBvZ3JhcGh5LFxuICBQb3NpdGlvblByb3BzLFxuICBMYXlvdXRQcm9wcyxcbiAgU3BhY2VQcm9wcyxcbiAgQ29sb3JQcm9wcyxcbiAgQm9yZGVyUHJvcHMsXG4gIFNoYWRvd1Byb3BzLFxuICBCYWNrZ3JvdW5kUHJvcHMsXG4gIFR5cG9ncmFwaHlQcm9wcyxcbiAgRmxleFByb3BzLFxuICBGbGV4Ym94UHJvcHMsXG59IGZyb20gJ3N0eWxlZC1zeXN0ZW0nO1xuXG5jb25zdCBGbGV4ID0gc3R5bGVkKCdkaXYnLCB7IHNob3VsZEZvcndhcmRQcm9wIH0pPFByb3BzPihcbiAgKCkgPT4gKHtcbiAgICBkaXNwbGF5OiAnZmxleCcsXG4gICAgbWluV2lkdGg6IDAsXG4gICAgbWFyZ2luOiAwLFxuICAgIHBhZGRpbmc6IDAsXG4gICAgYm94U2l6aW5nOiAnYm9yZGVyLWJveCcsXG4gIH0pLFxuICBwb3NpdGlvbixcbiAgbGF5b3V0LFxuICBmbGV4LFxuICBmbGV4Ym94LFxuICBzcGFjZSxcbiAgY29sb3IsXG4gIGJhY2tncm91bmQsXG4gIGJvcmRlcixcbiAgc2hhZG93LFxuICB0eXBvZ3JhcGh5XG4pO1xuXG5leHBvcnQgdHlwZSBQcm9wcyA9IFBvc2l0aW9uUHJvcHMgJlxuICBMYXlvdXRQcm9wcyAmXG4gIEZsZXhib3hQcm9wcyAmXG4gIEZsZXhQcm9wcyAmXG4gIFNwYWNlUHJvcHMgJlxuICBDb2xvclByb3BzICZcbiAgQm9yZGVyUHJvcHMgJlxuICBTaGFkb3dQcm9wcyAmXG4gIEJhY2tncm91bmRQcm9wcyAmXG4gIFR5cG9ncmFwaHlQcm9wcyAmXG4gIEFsbEhUTUxBdHRyaWJ1dGVzPEhUTUxFbGVtZW50PiAmIHtcbiAgICBhcz86IEFzO1xuICAgIGNoaWxkcmVuPzogUmVhY3ROb2RlO1xuICB9O1xuXG50eXBlIEFzPFAgPSBhbnk+ID0gUmVhY3QuRWxlbWVudFR5cGU8UD47XG5cbkZsZXguZGlzcGxheU5hbWUgPSAnRmxleCc7XG5leHBvcnQgeyBGbGV4IH07XG4iXX0= */");

Flex.displayName = 'Flex'; // TODO: TS: use responsive props here

var mapValues = function mapValues(value, valueMap) {
  if (value === undefined) return value; // If it's not a responsive prop, just map it directly

  if (typeof value === 'string' || value === undefined) {
    return valueMap[value];
  }

  return Array.isArray(value) ? value.map(function (x) {
    return valueMap[x];
  }) : undefined;
};

var alignToFlex = function alignToFlex(align) {
  return mapValues(align, {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end'
  });
};

var alignYToFlex = function alignYToFlex(align) {
  return mapValues(align, {
    top: 'flex-start',
    center: 'center',
    bottom: 'flex-end'
  });
}; // TODO: above and below should take a number which picks the proper breakpoint
// or a string which will be translated to pixels


var resolveResponsiveProps = function resolveResponsiveProps(_ref, values) {
  var above = _ref.above,
      below = _ref.below,
      breakpoints = _ref.breakpoints;

  if (values === void 0) {
    values = [];
  }

  if (!Array.isArray(breakpoints)) return values; // check if false but not 0

  if (!above && above !== 0 && !below && below !== 0) {
    return [null];
  }

  var lower = below !== undefined && typeof below === 'number' && below !== 0 ? Math.min(below, breakpoints.length + 1) : -1;
  var higher = above !== undefined && typeof above === 'number' ? above : breakpoints.length + 1;

  if (lower > higher) {
    return [null];
  }

  return [].concat(Array.from({
    length: breakpoints.length + 1
  }).map(function (_, i) {
    if (i <= lower || i > higher) {
      return Array.isArray(values[0]) ? values[0][i] || null : values[0];
    }

    return Array.isArray(values[1]) ? values[1][i] || null : values[1];
  }));
};

var spaceToNegativeMarginLeft = function spaceToNegativeMarginLeft(space) {
  return Array.isArray(space) ? // @ts-ignore
  space.map(function (s) {
    return s !== null ? -s : null;
  }) : typeof space === 'number' ? -space : "-" + String(space);
};

var ColumnContext = /*#__PURE__*/React.createContext({
  paddingLeft: [],
  paddingTop: []
});
var Columns = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$space = _ref.space,
      space = _ref$space === void 0 ? null : _ref$space,
      alignY = _ref.alignY,
      _ref$collapseBelow = _ref.collapseBelow,
      collapseBelow = _ref$collapseBelow === void 0 ? 0 : _ref$collapseBelow,
      children = _ref.children;

  var _useTheme = useTheme(),
      breakpoints = _useTheme.breakpoints;

  var alignFlex = alignY ? alignYToFlex(alignY) : null;
  var negativeMarginLeft = spaceToNegativeMarginLeft(space);
  var flexDirection = resolveResponsiveProps({
    below: collapseBelow,
    breakpoints: breakpoints
  }, ['column', 'row']);
  var paddingLeft = resolveResponsiveProps({
    below: collapseBelow,
    breakpoints: breakpoints
  }, [0, space]);
  var paddingTop = resolveResponsiveProps({
    below: collapseBelow,
    breakpoints: breakpoints
  }, [space, 0]);
  var marginLeft = resolveResponsiveProps({
    below: collapseBelow,
    breakpoints: breakpoints
  }, [0, negativeMarginLeft]);
  return /*#__PURE__*/React.createElement(Flex, {
    ref: ref,
    marginLeft: marginLeft,
    alignItems: alignFlex,
    flexDirection: flexDirection
  }, /*#__PURE__*/React.createElement(ColumnContext.Provider, {
    value: {
      paddingLeft: paddingLeft,
      paddingTop: paddingTop
    }
  }, children));
}); // TODO: TS Align: use responsive prop types

Columns.displayName = 'Columns';

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Column = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var width = _ref.width,
      children = _ref.children;

  var _React$useContext = React.useContext(ColumnContext),
      paddingLeft = _React$useContext.paddingLeft,
      paddingTop = _React$useContext.paddingTop;

  return /*#__PURE__*/React.createElement(ColumnBox, {
    ref: ref,
    width: width !== 'content' ? '100%' : undefined,
    flexShrink: width === 'content' ? 0 : undefined,
    flex: typeof width === 'number' ? "0 0 " + +width * 100 + "%" : width === 'content' ? null : 1
  }, /*#__PURE__*/React.createElement(Box, {
    height: "100%",
    paddingLeft: paddingLeft,
    paddingTop: paddingTop
  }, children));
});

var ColumnBox = /*#__PURE__*/_styled(Box, {
  target: "e14me5190",
  label: "ColumnBox"
})(process.env.NODE_ENV === "production" ? {
  name: "139r5wk",
  styles: "&:first-of-type>*{padding-top:0;}"
} : {
  name: "139r5wk",
  styles: "&:first-of-type>*{padding-top:0;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbHVtbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBOEI2QiIsImZpbGUiOiJDb2x1bW4udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IEJveCwgQm94UHJvcHMgfSBmcm9tICcuL0JveCc7XG5pbXBvcnQgeyBDb2x1bW5Db250ZXh0IH0gZnJvbSAnLi9Db2x1bW5zJztcblxuY29uc3QgQ29sdW1uID0gUmVhY3QuZm9yd2FyZFJlZjxIVE1MRGl2RWxlbWVudCwgQm94UHJvcHM+KFxuICAoeyB3aWR0aCwgY2hpbGRyZW4gfSwgcmVmKSA9PiB7XG4gICAgY29uc3QgeyBwYWRkaW5nTGVmdCwgcGFkZGluZ1RvcCB9ID0gUmVhY3QudXNlQ29udGV4dChDb2x1bW5Db250ZXh0KTtcblxuICAgIHJldHVybiAoXG4gICAgICA8Q29sdW1uQm94XG4gICAgICAgIHJlZj17cmVmfVxuICAgICAgICB3aWR0aD17d2lkdGggIT09ICdjb250ZW50JyA/ICcxMDAlJyA6IHVuZGVmaW5lZH1cbiAgICAgICAgZmxleFNocmluaz17d2lkdGggPT09ICdjb250ZW50JyA/IDAgOiB1bmRlZmluZWR9XG4gICAgICAgIGZsZXg9e1xuICAgICAgICAgIHR5cGVvZiB3aWR0aCA9PT0gJ251bWJlcidcbiAgICAgICAgICAgID8gYDAgMCAkeyt3aWR0aCAqIDEwMH0lYFxuICAgICAgICAgICAgOiB3aWR0aCA9PT0gJ2NvbnRlbnQnXG4gICAgICAgICAgICA/IG51bGxcbiAgICAgICAgICAgIDogMVxuICAgICAgICB9XG4gICAgICA+XG4gICAgICAgIDxCb3ggaGVpZ2h0PVwiMTAwJVwiIHBhZGRpbmdMZWZ0PXtwYWRkaW5nTGVmdH0gcGFkZGluZ1RvcD17cGFkZGluZ1RvcH0+XG4gICAgICAgICAge2NoaWxkcmVufVxuICAgICAgICA8L0JveD5cbiAgICAgIDwvQ29sdW1uQm94PlxuICAgICk7XG4gIH1cbik7XG5cbmNvbnN0IENvbHVtbkJveCA9IHN0eWxlZChCb3gpYFxuICAmOmZpcnN0LW9mLXR5cGUgPiAqIHtcbiAgICBwYWRkaW5nLXRvcDogMDtcbiAgfVxuYDtcblxuQ29sdW1uLmRpc3BsYXlOYW1lID0gJ0NvbHVtbic7XG5leHBvcnQgeyBDb2x1bW4gfTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

Column.displayName = 'Column';

var Grid = /*#__PURE__*/_styled('div', {
  shouldForwardProp: shouldForwardProp,
  target: "e1jef8iy0",
  label: "Grid"
})(function () {
  return {
    display: 'grid',
    margin: 0,
    padding: 0,
    boxSizing: 'border-box'
  };
}, grid, position, layout, space, color, background, border, flex, flexbox, shadow, typography, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkdyaWQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTRCYSIsImZpbGUiOiJHcmlkLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEFsbEhUTUxBdHRyaWJ1dGVzLCBSZWFjdE5vZGUgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgc2hvdWxkRm9yd2FyZFByb3AgZnJvbSAnQHN0eWxlZC1zeXN0ZW0vc2hvdWxkLWZvcndhcmQtcHJvcCc7XG5pbXBvcnQge1xuICBwb3NpdGlvbixcbiAgYm9yZGVyLFxuICBzcGFjZSxcbiAgbGF5b3V0LFxuICBiYWNrZ3JvdW5kLFxuICBjb2xvcixcbiAgZ3JpZCxcbiAgZmxleCxcbiAgZmxleGJveCxcbiAgc2hhZG93LFxuICB0eXBvZ3JhcGh5LFxuICBQb3NpdGlvblByb3BzLFxuICBMYXlvdXRQcm9wcyxcbiAgU3BhY2VQcm9wcyxcbiAgQ29sb3JQcm9wcyxcbiAgQm9yZGVyUHJvcHMsXG4gIFNoYWRvd1Byb3BzLFxuICBCYWNrZ3JvdW5kUHJvcHMsXG4gIFR5cG9ncmFwaHlQcm9wcyxcbiAgR3JpZFByb3BzLFxuICBGbGV4UHJvcHMsXG4gIEZsZXhib3hQcm9wcyxcbn0gZnJvbSAnc3R5bGVkLXN5c3RlbSc7XG5cbmNvbnN0IEdyaWQgPSBzdHlsZWQoJ2RpdicsIHsgc2hvdWxkRm9yd2FyZFByb3AgfSkoXG4gICgpID0+ICh7XG4gICAgZGlzcGxheTogJ2dyaWQnLFxuICAgIG1hcmdpbjogMCxcbiAgICBwYWRkaW5nOiAwLFxuICAgIGJveFNpemluZzogJ2JvcmRlci1ib3gnLFxuICB9KSxcbiAgZ3JpZCxcbiAgcG9zaXRpb24sXG4gIGxheW91dCxcbiAgc3BhY2UsXG4gIGNvbG9yLFxuICBiYWNrZ3JvdW5kLFxuICBib3JkZXIsXG4gIGZsZXgsXG4gIGZsZXhib3gsXG4gIHNoYWRvdyxcbiAgdHlwb2dyYXBoeVxuKTtcblxuZXhwb3J0IHR5cGUgUHJvcHMgPSBQb3NpdGlvblByb3BzICZcbiAgTGF5b3V0UHJvcHMgJlxuICBHcmlkUHJvcHMgJlxuICBGbGV4UHJvcHMgJlxuICBGbGV4Ym94UHJvcHMgJlxuICBTcGFjZVByb3BzICZcbiAgQ29sb3JQcm9wcyAmXG4gIEJvcmRlclByb3BzICZcbiAgU2hhZG93UHJvcHMgJlxuICBCYWNrZ3JvdW5kUHJvcHMgJlxuICBUeXBvZ3JhcGh5UHJvcHMgJlxuICBBbGxIVE1MQXR0cmlidXRlczxIVE1MRWxlbWVudD4gJiB7XG4gICAgYXM/OiBBcztcbiAgICBjaGlsZHJlbj86IFJlYWN0Tm9kZTtcbiAgfTtcblxudHlwZSBBczxQID0gYW55PiA9IFJlYWN0LkVsZW1lbnRUeXBlPFA+O1xuXG5HcmlkLmRpc3BsYXlOYW1lID0gJ0dyaWQnO1xuZXhwb3J0IHsgR3JpZCB9O1xuIl19 */");

Grid.displayName = 'Grid';
var Hidden = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var above = _ref.above,
      below = _ref.below,
      children = _ref.children;

  var _useTheme = useTheme(),
      breakpoints = _useTheme.breakpoints;

  var display = resolveResponsiveProps({
    above: above,
    below: below,
    breakpoints: breakpoints
  }, ['none', 'block']);
  return /*#__PURE__*/React.createElement(Box, {
    display: display,
    ref: ref
  }, children);
});
Hidden.displayName = 'Hidden';
var Inline = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$space = _ref.space,
      space = _ref$space === void 0 ? null : _ref$space,
      align = _ref.align,
      collapseBelow = _ref.collapseBelow,
      children = _ref.children;
  var theme = useTheme();
  var negativeSpace = !space ? 0 : -Number(space);
  var marginTop = get(theme.space, Number(space));
  var alignFlex = align ? alignToFlex(align) : null;
  var flexDirection = resolveResponsiveProps({
    below: collapseBelow,
    breakpoints: theme.breakpoints
  }, ['column', 'row']);
  return /*#__PURE__*/React.createElement(NegativeMarginTop, {
    pseudoMarginTop: marginTop
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: alignFlex,
    flexWrap: "wrap",
    marginLeft: negativeSpace,
    alignItems: alignFlex,
    flexDirection: flexDirection,
    ref: ref
  }, React.Children.map(children, function (child) {
    return child !== null && child !== undefined ? /*#__PURE__*/React.createElement(Box, {
      paddingLeft: space,
      paddingTop: space
    }, child) : null;
  })));
});

var NegativeMarginTop = /*#__PURE__*/_styled(Box, {
  target: "eqlik450",
  label: "NegativeMarginTop"
})("padding-top:1px;&::before{content:'';display:block;margin-top:-", function (p) {
  return p.pseudoMarginTop;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

Inline.displayName = 'Inline';

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Placeholder = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'auto' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 120 : _ref$height,
      label = _ref.label;
  return /*#__PURE__*/React.createElement(PlaceholderBox, {
    width: width,
    height: height,
    ref: ref
  }, label ? /*#__PURE__*/React.createElement(Box, {
    as: "p",
    px: "8px"
  }, label) : /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("line", {
    x1: "0",
    y1: "0",
    x2: "100%",
    y2: "100%"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "100%",
    y1: "0",
    x2: "0",
    y2: "100%"
  })));
});

var PlaceholderBox = /*#__PURE__*/_styled(Box, {
  target: "e1lk34zc0",
  label: "PlaceholderBox"
})(process.env.NODE_ENV === "production" ? {
  name: "3dhhu3",
  styles: "position:relative;display:flex;justify-content:center;align-items:center;background:rgba(73, 80, 87, 0.05);border:1px solid rgba(73, 80, 87, 0.5);overflow:hidden;p{margin:0;padding:0;text-align:center;color:rgba(73, 80, 87, 0.8);font-family:Courier,monospace;font-weight:500;font-size:14px;line-height:20px;box-sizing:border-box;}svg{position:absolute;width:100%;height:100%;margin:0;padding:0;line{stroke-width:1px;stroke:rgba(73, 80, 87, 0.2);}}"
} : {
  name: "3dhhu3",
  styles: "position:relative;display:flex;justify-content:center;align-items:center;background:rgba(73, 80, 87, 0.05);border:1px solid rgba(73, 80, 87, 0.5);overflow:hidden;p{margin:0;padding:0;text-align:center;color:rgba(73, 80, 87, 0.8);font-family:Courier,monospace;font-weight:500;font-size:14px;line-height:20px;box-sizing:border-box;}svg{position:absolute;width:100%;height:100%;margin:0;padding:0;line{stroke-width:1px;stroke:rgba(73, 80, 87, 0.2);}}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBsYWNlaG9sZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEyQmtDIiwiZmlsZSI6IlBsYWNlaG9sZGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBCb3ggfSBmcm9tICcuL0JveCc7XG5cbmNvbnN0IFBsYWNlaG9sZGVyID0gUmVhY3QuZm9yd2FyZFJlZjxIVE1MRGl2RWxlbWVudCwgUGxhY2Vob2xkZXJQcm9wcz4oXG4gICh7IHdpZHRoID0gJ2F1dG8nLCBoZWlnaHQgPSAxMjAsIGxhYmVsIH0sIHJlZikgPT4gKFxuICAgIDxQbGFjZWhvbGRlckJveCB3aWR0aD17d2lkdGh9IGhlaWdodD17aGVpZ2h0fSByZWY9e3JlZn0+XG4gICAgICB7bGFiZWwgPyAoXG4gICAgICAgIDxCb3ggYXM9XCJwXCIgcHg9XCI4cHhcIj5cbiAgICAgICAgICB7bGFiZWx9XG4gICAgICAgIDwvQm94PlxuICAgICAgKSA6IChcbiAgICAgICAgPHN2ZyB4bWxucz1cImh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnXCI+XG4gICAgICAgICAgPGxpbmUgeDE9XCIwXCIgeTE9XCIwXCIgeDI9XCIxMDAlXCIgeTI9XCIxMDAlXCIgLz5cbiAgICAgICAgICA8bGluZSB4MT1cIjEwMCVcIiB5MT1cIjBcIiB4Mj1cIjBcIiB5Mj1cIjEwMCVcIiAvPlxuICAgICAgICA8L3N2Zz5cbiAgICAgICl9XG4gICAgPC9QbGFjZWhvbGRlckJveD5cbiAgKVxuKTtcblxuZXhwb3J0IHR5cGUgUGxhY2Vob2xkZXJQcm9wcyA9IHtcbiAgd2lkdGg/OiBzdHJpbmcgfCBudW1iZXI7XG4gIGhlaWdodD86IHN0cmluZyB8IG51bWJlcjtcbiAgbGFiZWw/OiBzdHJpbmc7XG59O1xuXG5jb25zdCBQbGFjZWhvbGRlckJveCA9IHN0eWxlZChCb3gpYFxuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBiYWNrZ3JvdW5kOiByZ2JhKDczLCA4MCwgODcsIDAuMDUpO1xuICBib3JkZXI6IDFweCBzb2xpZCByZ2JhKDczLCA4MCwgODcsIDAuNSk7XG4gIG92ZXJmbG93OiBoaWRkZW47XG5cbiAgcCB7XG4gICAgbWFyZ2luOiAwO1xuICAgIHBhZGRpbmc6IDA7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgIGNvbG9yOiByZ2JhKDczLCA4MCwgODcsIDAuOCk7XG4gICAgZm9udC1mYW1pbHk6IENvdXJpZXIsIG1vbm9zcGFjZTtcbiAgICBmb250LXdlaWdodDogNTAwO1xuICAgIGZvbnQtc2l6ZTogMTRweDtcbiAgICBsaW5lLWhlaWdodDogMjBweDtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB9XG5cbiAgc3ZnIHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgaGVpZ2h0OiAxMDAlO1xuICAgIG1hcmdpbjogMDtcbiAgICBwYWRkaW5nOiAwO1xuXG4gICAgbGluZSB7XG4gICAgICBzdHJva2Utd2lkdGg6IDFweDtcbiAgICAgIHN0cm9rZTogcmdiYSg3MywgODAsIDg3LCAwLjIpO1xuICAgIH1cbiAgfVxuYDtcblxuUGxhY2Vob2xkZXIuZGlzcGxheU5hbWUgPSAnUGxhY2Vob2xkZXInO1xuZXhwb3J0IHsgUGxhY2Vob2xkZXIgfTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});

Placeholder.displayName = 'Placeholder';

var Ratio = _styled("div", {
  target: "e14evxnu0",
  label: "Ratio"
})("position:relative;box-sizing:border-box;&::after{content:'';display:block;height:0;padding-bottom:", function (p) {
  return p.ratio ? (1 / p.ratio || 0.5) * 100 + "%" : '56.25%';
}, ";}>*{position:absolute;top:0;left:0;width:100%;height:100%;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJhdGlvLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFb0MiLCJmaWxlIjoiUmF0aW8udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5jb25zdCBSYXRpbyA9IHN0eWxlZC5kaXY8UmF0aW9Qcm9wcz5gXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcblxuICAmOjphZnRlciB7XG4gICAgY29udGVudDogJyc7XG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgaGVpZ2h0OiAwO1xuICAgIHBhZGRpbmctYm90dG9tOiAke3AgPT5cbiAgICAgIHAucmF0aW8gPyBgJHsoMSAvIHAucmF0aW8gfHwgMC41KSAqIDEwMH0lYCA6ICc1Ni4yNSUnfTtcbiAgfVxuXG4gID4gKiB7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHRvcDogMDtcbiAgICBsZWZ0OiAwO1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGhlaWdodDogMTAwJTtcbiAgfVxuYDtcblxuZXhwb3J0IHR5cGUgUmF0aW9Qcm9wcyA9IHtcbiAgcmF0aW86IG51bWJlcjtcbn07XG5cblJhdGlvLmRpc3BsYXlOYW1lID0gJ1JhdGlvJztcbmV4cG9ydCB7IFJhdGlvIH07XG4iXX0= */"));

Ratio.displayName = 'Ratio';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var resolveFlexProps = function resolveFlexProps(align) {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: alignToFlex(align)
  };
};

var Stack = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$space = _ref.space,
      space = _ref$space === void 0 ? null : _ref$space,
      align = _ref.align,
      children = _ref.children;
  var stackItems = React.Children.toArray(children);
  var stackCount = stackItems.length;
  var flexProps = align ? resolveFlexProps(align) : {};
  return /*#__PURE__*/React.createElement(Box, {
    ref: ref
  }, stackItems.map(function (child, index) {
    return child !== null && child !== undefined ? /*#__PURE__*/React.createElement(Box, _extends({
      key: index,
      paddingBottom: index !== stackCount - 1 ? space : null
    }, flexProps), child) : null;
  }));
}); // TODO: TS Align: use responsive prop types

Stack.displayName = 'Stack';
export { Box, Column, Columns, Flex, Grid, Hidden, Inline, LayoutProvider, Placeholder, Ratio, Stack, useTheme };